import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface CollectionCodeProductState extends ListState<any> {
}
class CollectionCodeProductModule extends ListModule<CollectionCodeProductState, any, any> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
  };
  actions = {
    async getAll(
      context: ActionContext<CollectionCodeProductState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/CollectionCode/products", {
        params: payload.data,
      });
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getInfo(
      context: ActionContext<CollectionCodeProductState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/CollectionCode/products/info/" + payload.data.code
      );
      return reponse.data.result;
    },
    async getStampActivateReasons(
      context: ActionContext<CollectionCodeProductState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/CollectionCode/stamp-activate-reasons"
      );
      return result;
    },
    async stampActivate(
      context: ActionContext<CollectionCodeProductState, any>,
      payload: any
    ) {
      await Ajax.put(`/api/services/app/CollectionCode/${payload.data.mainSerialNo}/stamp-activate`, payload.data);
    },
    async stampDeactivate(
      context: ActionContext<CollectionCodeProductState, any>,
      payload: any
    ) {
      await Ajax.put(`/api/services/app/CollectionCode/${payload.data.mainSerialNo}/stamp-deactivate`);
    },
    async changeStamp(
      context: ActionContext<CollectionCodeProductState, any>,
      payload: any
    ) {
      await Ajax.put(`/api/services/app/CollectionCode/change-stamp`, payload.data);
    },
    async changeStampCollectionCodetInfo(
      context: ActionContext<CollectionCodeProductState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/CollectionCode/change-stamp/info/" + payload.data.code
      );
      return reponse.data.result;
    },
  };

  mutations = {
    setCurrentPage(state: CollectionCodeProductState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: CollectionCodeProductState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const collectionCodeProductModule = new CollectionCodeProductModule();
export default collectionCodeProductModule;
